import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';


@Component({
  selector: 'app-vacancy-details',
  templateUrl: './vacancy-details.component.html',
  styleUrls: ['./vacancy-details.component.css']
})
export class VacancyDetailsComponent implements OnInit {

  constructor(private _Activatedroute: ActivatedRoute,private homeService_: HomeService) {
   }

  id:any
  vacancyName:string = ''
  vacancyDsc:string = ''
  vacancyDetails:string = ''
  load:boolean=false
  selectedItem: any
  arrayVecancyCategory:any
  arrayVecancy:any

  ngOnInit(): void {
this.load = false;
this.id = this._Activatedroute.snapshot.paramMap.get("id")
this.homeService_.getPost('getPost','', 'en', '', 'VecancyCategory', 'NTROOT0', '', '-1').subscribe(data => {
  this.arrayVecancyCategory = data



  this.homeService_.getPost('getPostById',this.id, 'en', '', 'Vecancy', '', '', '1').subscribe(data => {
    let arr = data as any[]
    this.vacancyName = arr[0]['postTitle']
    this.vacancyDsc = arr[0]['postSubTitle']
    this.vacancyDetails = arr[0]['postDetails']
    this.load = true
  })
  });


  }

}
